module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn margin-top-30"
  }, [(_vm.spinner_systems) ? _c('GeneralSpinner') : _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.systems), function(system) {
    return _c('div', {
      staticClass: "col-sm-6 col-md-4 col-xl-3"
    }, [_c('div', {
      staticClass: "card border-primary"
    }, [_c('div', {
      staticClass: "card-header text-center"
    }, [_vm._v("\n          " + _vm._s(system.name) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "card-body"
    }, [_c('gmap-map', {
      attrs: {
        "id": "mapsystem",
        "center": {
          lat: parseFloat(system.coordinates.split('#')[0]),
          lng: parseFloat(system.coordinates.split('#')[1])
        },
        "zoom": 9,
        "map-type-id": "hybrid"
      }
    }, [_c('gmap-marker', {
      attrs: {
        "position": {
          lat: parseFloat(system.coordinates.split('#')[0]),
          lng: parseFloat(system.coordinates.split('#')[1])
        }
      }
    })], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "card-footer"
    }, [_c('div', {
      staticClass: "row flex-nowrap"
    }, [_c('div', {
      staticClass: "col-xs-9 col-sm-9 col-md-9 col-lg-9 col-xl-9"
    }, [_c('button', {
      staticClass: "btn btn-outline-primary btn-block",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.selectSystem(system)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-bullseye"
    }), _vm._v(" " + _vm._s(_vm.web_texts.select) + "\n              ")])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3"
    }, [_c('button', {
      staticClass: "btn btn-outline-success btn-block",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.goNotifications(system)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-bell-o"
    })])])])])])])
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39aee5a9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/SelectSystem.vue
// module id = 545
// module chunks = 1